import { connect } from 'react-redux';
import * as actions from './actions';
import RoomRecordings from './RoomRecordings';

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingList: state.roomRecordings.isFetchingList,
    roomRecordings: state.roomRecordings.roomRecordings,
    errors: state.roomRecordings.errors,
    success: state.roomRecordings.success,
    hasServerError: state.roomRecordings.hasServerError,
    view: state.loginLayout.view,
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => ({
  fetchRoomRecordings: (token) => dispatch(actions.fetchRoomRecordings(token)),
  deleteRoomRecording: (token, id) => dispatch(actions.deleteRoomRecording(token, id)),
  clearErrors: () => dispatch(actions.clearErrors())
});

const RoomRecordingsContainer = connect(mapStateToProps, mapDispatchToProps)(
  RoomRecordings,
);

export default RoomRecordingsContainer;


// WEBPACK FOOTER //
// src/routes/RoomRecordings/RoomRecordingsContainer.js